import React from 'react';
import { MapPin, Clock, DollarSign } from 'lucide-react';

const AREA_TYPE_LABELS = {
  city: 'City',
  county: 'County',
  state: 'Region',
  country: 'Country',
  custom: 'Service area',
};

const VendorServiceAreas = ({ areas = [] }) => {
  if (!areas?.length) return null;

  return (
    <div className="pb-6 border-b border-gray-200">
      <h2 className="text-lg sm:text-xl font-light text-black mb-4">Service areas</h2>
      <p className="text-sm text-gray-600 font-light mb-4">
        This vendor serves clients in the following locations.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {areas.map((area) => {
          const geo = [area.city, area.state, area.country].filter(Boolean).join(', ');
          return (
            <div
              key={area.id}
              className="flex gap-3 p-4 rounded-xl border border-gray-200 bg-gray-50/50"
            >
              <div className="w-9 h-9 rounded-lg bg-black text-white flex items-center justify-center flex-shrink-0">
                <MapPin className="w-4 h-4" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900">{area.area_name}</p>
                <p className="text-xs text-gray-500 mt-0.5">
                  {AREA_TYPE_LABELS[area.area_type] || 'Area'}
                  {geo ? ` · ${geo}` : ''}
                </p>
                <div className="flex flex-wrap gap-2 mt-2 text-[11px] text-gray-600">
                  {Number(area.travel_fee) > 0 && (
                    <span className="inline-flex items-center gap-0.5">
                      <DollarSign className="w-3 h-3" />
                      +${Number(area.travel_fee).toFixed(0)} travel
                    </span>
                  )}
                  {Number(area.travel_time_minutes) > 0 && (
                    <span className="inline-flex items-center gap-0.5">
                      <Clock className="w-3 h-3" />
                      ~{area.travel_time_minutes} min
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VendorServiceAreas;
